export const authenticateUserValues = {
  TOKEN: 'token',
  DOMAIN: 'domain',
  SPARROW_APPS_TOKEN: 'sparrow_apps_token',
  DEVELOPER_ONBOARDING_TRACKER: 'redirection_url',
  LOGIN_DOMAIN: 'login_domain'
};

export const loginURL = process.env.REACT_APP_APP_V1_LOGIN_URL;

export const product = process.env.REACT_APP_APP_PRODUCT_NAME;

export const developerDocs = process.env.REACT_APP_DEVELOPER_DOCUMENTATION_URL;

export const authValuesForLogout = [
  authenticateUserValues.LOGIN_DOMAIN,
  authenticateUserValues.DEVELOPER_ONBOARDING_TRACKER,
  authenticateUserValues.TOKEN
];

export const customPillVaraints = {
  DEFAULT: 'default',
  SUCCESS: 'success',
  WARNING: 'warning',
  ACCENT: 'accent',
  SECONDARY: 'secondary'
};

export const urlRegex =
  /(https:\/\/www\.|http:\/\/www\.|https:\/\/|http:\/\/)?[a-zA-Z]{2,}(\.[a-zA-Z]{2,})(\.[a-zA-Z]{2,})?\/[a-zA-Z0-9]{2,}|((https:\/\/www\.|http:\/\/www\.|https:\/\/|http:\/\/)?[a-zA-Z]{2,}(\.[a-zA-Z]{2,})(\.[a-zA-Z]{2,})?)|(https:\/\/www\.|http:\/\/www\.|https:\/\/|http:\/\/)?[a-zA-Z0-9]{2,}\.[a-zA-Z0-9]{2,}\.[a-zA-Z0-9]{2,}(\.[a-zA-Z0-9]{2,})?/;

export const productConstants = {
  SURVEYSPARROW: 'surveysparrow',
  SURVEYSPARROW_CAPS: 'SurveySparrow'
};

export const SHOW_TOUR = 'showTour';

export const booleanStringValues = {
  TRUE: 'True',
  FALSE: 'False'
};

export const iparamType = {
  EMAIL: 'email',
  API_KEY: 'api_key',
  URL: 'url',
  PHONE_NUMBER: 'phone_number',
  TEXT: 'text',
  NUMBER: 'number',
  DATE: 'date',
  RADIO: 'radio'
};

export const APP_STORE = 'app_store'

export const PRODUCTS_LIST = {
  SURVEYSPARROW: {
    value: 'surveysparrow',
    label: 'SurveySparrow',
    redirectLink: process.env.REACT_APP_APP_V1_URL
  },
  THRIVESPARROW: {
    value: 'thrivesparrow',
    label: 'ThriveSparrow',
    redirectLink: process.env.REACT_APP_THRIVE_REDIRECTION_URL
  },
  SPARROWDESK: {
    value: 'sparrowdesk',
    label: 'SparrowDesk',
    redirectLink: process.env.REACT_APP_SPARROWDESK_REDIRECTION_URL
  },
  SPARROWGENIE: {
    value: 'sparrowgenie',
    label: 'SparrowGenie',
    redirectLink: process.env.REACT_APP_SPARROWGENIE_REDIRECTION_URL
  },
  SPARROWCRM: {
    value: 'sparrowcrm',
    label: 'SparrowCRM',
    redirectLink: process.env.REACT_APP_SPARROWCRM_REDIRECTION_URL
  }
}